import { BaseRestRepository } from './baseRestRepository';
import type { PropertyManagerDto, UpdatePropertyManagerMeDto, UpdatePropertyManagerMePasswordDto } from '~/swagger/portal/Api';

const ME_URL = '/api/me';

export class MeRepository extends BaseRestRepository {
  public async getProfile(): Promise<PropertyManagerDto> {
    const response = await this.fetchWithAuth(ME_URL);
    return await this.getJsonResponse(response);
  }

  public async updateProfile(model: UpdatePropertyManagerMeDto): Promise<PropertyManagerDto> {
    const response = await this.fetchWithAuth(ME_URL, {
      method: 'PUT',
      body: JSON.stringify(model),
    });
    return await this.getJsonResponse(response);
  }

  public async updateProfileImage(image: File): Promise<PropertyManagerDto> {
    const formData = new FormData();
    formData.append('ImageFile', image);
    const response = await this.fetchWithAuth(ME_URL + '/image', {
      method: 'POST',
      headers: { 'content-type': 'multipart/form-data' },
      body: formData,
    });
    return await this.getJsonResponse(response);
  }

  public async changePassword(model: UpdatePropertyManagerMePasswordDto): Promise<PropertyManagerDto> {
    const response = await this.fetchWithAuth(ME_URL + '/password', {
      method: 'PUT',
      body: JSON.stringify(model),
    });
    return await this.getJsonResponse(response);
  }
}
